import { useEffect, useState } from "react";
import Input from "../../extra/Input";
import SettingBox from "./SettingBox";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getSetting,
  updateSetting,
  handleToggleSwitch,
  handleSellerToggleSwitch,
  updateAppVersion,
} from "../../store/setting/setting.action";
import { getWithdraw } from "../../store/withdraw/withdraw.action";
import Button from "../../extra/Button";
import ToggleSwitch from "../../extra/ToggleSwitch";
import "react-quill/dist/quill.snow.css";
import InfoTooltip from "../../extra/InfoTooltip";
import { auctionSetting, chargesSetting, openAISetting, privateKeyJson, resendApiSetting, withdrawalSetting, zegoApp } from "../../extra/infoContent";

const Setting = (props) => {
  const { setting } = useSelector((state) => state.setting);

  const dispatch = useDispatch();
  // box 1
  const [settingId, setSettingId] = useState("");
  const [zegoAppId, setZegoAppId] = useState("");
  const [paymentReminderForLiveAuction, setPaymentReminderForLiveAuction] = useState("");
  const [minPayout, setMinPayout] = useState("");
  const [paymentReminderForManualAuction, setPaymentReminderForManualAuction] = useState("");
  const [zegoAppSignIn, setZegoAppSignIn] = useState("");
  // box 2
  // const [privacyPolicyLink, setPrivacyPolicyLink] = useState("");
  // const [privacyPolicyText, setPrivacyPolicyText] = useState("");
  const [resendkey, setResendKey] = useState("");
  // const [termsAndConditionsLink, setTermsAndConditionsLink] = useState('');
  const [openaiApiKey, setOpenaiApiKey] = useState("");



  const [cancelOrderCharges, setCancelOrderCharges] = useState("");
  const [adminCommissionCharges, setAdminCommissionCharges] = useState("");
  const [priceMarkupPercent, setPriceMarkupPercent] = useState(5);

  // Gift/Coin conversion settings
  const [coinsPerCedi, setCoinsPerCedi] = useState(10);
  const [giftPlatformCommission, setGiftPlatformCommission] = useState(30);
  const [minGiftWithdrawal, setMinGiftWithdrawal] = useState(100);

  // Product limit settings
  const [defaultProductLimit, setDefaultProductLimit] = useState(50);

  // Shipping / delivery fee engine (distance + weight)
  const defaultShipping = {
    basePickup: 14,
    baseDoor: 20,
    perKmTiers: [
      { maxKm: 15, rate: 2 },
      { maxKm: 50, rate: 1.5 },
      { maxKm: null, rate: 1 },
    ],
    weightFreeKg: 5,
    weightSurchargePerKg: 2,
    roadFactor: 1.3,
    currency: "GHS",
    isActive: true,
  };
  const [shipping, setShipping] = useState(defaultShipping);
  const setShipField = (key, val) => setShipping((prev) => ({ ...prev, [key]: val }));
  const setTierRate = (idx, val) =>
    setShipping((prev) => {
      const tiers = (prev.perKmTiers || []).map((t, i) => (i === idx ? { ...t, rate: val } : t));
      return { ...prev, perKmTiers: tiers };
    });

  // Flash Sale settings
  const [flashSaleEndDate, setFlashSaleEndDate] = useState("");
  const [flashSaleEnabled, setFlashSaleEnabled] = useState(false);

  const [isFakeData, setIsFakeData] = useState(false);

  // Twilio SMS OTP Settings
  const [twilioAccountSid, setTwilioAccountSid] = useState("");
  const [twilioAuthToken, setTwilioAuthToken] = useState("");
  const [twilioVerifyServiceSid, setTwilioVerifyServiceSid] = useState("");
  const [twilioSwitch, setTwilioSwitch] = useState(true);

  // App Version Settings
  const [iosCurrentVersion, setIosCurrentVersion] = useState("1.0.0");
  const [iosMinimumVersion, setIosMinimumVersion] = useState("1.0.0");
  const [iosStoreUrl, setIosStoreUrl] = useState("");
  const [iosReleaseNotes, setIosReleaseNotes] = useState("");
  const [androidCurrentVersion, setAndroidCurrentVersion] = useState("1.0.0");
  const [androidMinimumVersion, setAndroidMinimumVersion] = useState("1.0.0");
  const [androidStoreUrl, setAndroidStoreUrl] = useState("");
  const [androidReleaseNotes, setAndroidReleaseNotes] = useState("");
  const [forceUpdate, setForceUpdate] = useState(false);

  // box 3

  // box 7
  const [isAddProductRequest, setIsAddProductRequest] = useState(false);
  const [isUpdateProductRequest, setIsUpdateProductRequest] = useState(false);
  const [privateKey, setPrivateKey] = useState("");

  const [addressProofRequired, setAddressProofRequired] = useState(setting?.addressProofRequired || false);
  const [addressProofActive, setAddressProofActive] = useState(setting?.addressProofActive || false);

  const [govIdRequired, setGovIdRequired] = useState(setting?.govIdRequired || false);
  const [govIdActive, setGovIdActive] = useState(setting?.govIdActive || false);

  const [registrationCertRequired, setRegistrationCertRequired] = useState(setting?.registrationCertRequired || false);
  const [registrationCertActive, setRegistrationCertActive] = useState(setting?.registrationCertActive || false);


  const [error, setError] = useState({
    zegoAppId: "",
    paymentReminderForLiveAuction: "",
    minPayout: "",
    paymentReminderForManualAuction: "",
    zegoAppSignIn: "",
    // privacyPolicyLink: "",
    resendKey: "",
    // termsAndConditionsLink: "",
    openaiApiKey: "",
    // privacyPolicyText: "",
    // shippingCharges: "",
    withdrawCharges: "",
    withdrawLimit: "",
    cancelOrderCharges: "",
    adminCommissionCharges: "",
    razorPayId: "",
    razorSecretKey: "",
    stripePublishableKey: "",
    stripeSecretKey: "",
    privateKey,
  });


  useEffect(() => {
    dispatch(getSetting());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getWithdraw());
  }, [dispatch]);

  //onselect function of selecting multiple values

  //onRemove function for remove multiple values

  useEffect(() => {
    setSettingId(setting?._id);
    // box 1
    setZegoAppId(setting?.zegoAppId);
    setPaymentReminderForLiveAuction(setting?.paymentReminderForLiveAuction);
    setMinPayout(setting?.minPayout);
    setPaymentReminderForManualAuction(setting?.paymentReminderForManualAuction);
    setZegoAppSignIn(setting?.zegoAppSignIn);
    // box 2
    // setPrivacyPolicyLink(setting?.privacyPolicyLink);
    // setPrivacyPolicyText(setting?.privacyPolicyText);
    setIsFakeData(setting?.isFakeData);

    // box 7
    setIsAddProductRequest(setting?.isAddProductRequest);
    setIsUpdateProductRequest(setting?.isUpdateProductRequest);
    setPrivateKey(JSON.stringify(setting?.privateKey));
    setAdminCommissionCharges(setting?.adminCommissionCharges);
    setCancelOrderCharges(setting?.cancelOrderCharges);
    setPriceMarkupPercent(setting?.priceMarkupPercent ?? 5);
    setResendKey(setting?.resendApiKey);
    // setTermsAndConditionsLink(setting?.termsAndConditionsLink || '');
    setOpenaiApiKey(setting?.openaiApiKey);

    // Gift/Coin conversion settings
    setCoinsPerCedi(setting?.coinsPerCedi || 10);
    setGiftPlatformCommission(setting?.giftPlatformCommission || 30);
    setMinGiftWithdrawal(setting?.minGiftWithdrawal || 100);

    // Product limit settings
    setDefaultProductLimit(setting?.defaultProductLimit || 50);

    // Shipping / delivery fee engine
    if (setting?.shipping) {
      setShipping({
        ...defaultShipping,
        ...setting.shipping,
        perKmTiers:
          Array.isArray(setting.shipping.perKmTiers) && setting.shipping.perKmTiers.length
            ? setting.shipping.perKmTiers
            : defaultShipping.perKmTiers,
      });
    }

    // Flash Sale settings
    if (setting?.flashSaleEndDate) {
      const date = new Date(setting.flashSaleEndDate);
      const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      setFlashSaleEndDate(localDate.toISOString().slice(0, 16));
    } else {
      setFlashSaleEndDate("");
    }
    setFlashSaleEnabled(setting?.flashSaleEnabled || false);

    // Twilio SMS OTP Settings
    setTwilioAccountSid(setting?.twilioAccountSid || "");
    setTwilioAuthToken(setting?.twilioAuthToken || "");
    setTwilioVerifyServiceSid(setting?.twilioVerifyServiceSid || "");
    setTwilioSwitch(setting?.twilioSwitch !== false); // Default to true if not set

    // App Version Settings
    setIosCurrentVersion(setting?.appVersion?.ios?.currentVersion || "1.0.0");
    setIosMinimumVersion(setting?.appVersion?.ios?.minimumVersion || "1.0.0");
    setIosStoreUrl(setting?.appVersion?.ios?.storeUrl || "");
    setIosReleaseNotes(setting?.appVersion?.ios?.releaseNotes || "");
    setAndroidCurrentVersion(setting?.appVersion?.android?.currentVersion || "1.0.0");
    setAndroidMinimumVersion(setting?.appVersion?.android?.minimumVersion || "1.0.0");
    setAndroidStoreUrl(setting?.appVersion?.android?.storeUrl || "");
    setAndroidReleaseNotes(setting?.appVersion?.android?.releaseNotes || "");
    setForceUpdate(setting?.appVersion?.forceUpdate || false);
  }, [setting]);

  const handleSubmit = () => {

    if (
      !zegoAppId ||
      !paymentReminderForLiveAuction ||
      !minPayout ||
      !paymentReminderForManualAuction ||
      !zegoAppSignIn ||
      // !privacyPolicyLink ||
      !resendkey ||
      // !termsAndConditionsLink ||
      !openaiApiKey ||
      // !privacyPolicyText ||

      !cancelOrderCharges ||
      cancelOrderCharges <= 0 ||
      !adminCommissionCharges ||
      adminCommissionCharges <= 0
    ) {
      let error = {};
      if (!zegoAppId) error.zegoAppId = "ZegoAppId Is Required ";
      if (!paymentReminderForLiveAuction)
        error.paymentReminderForLiveAuction =
          "Payment Reminder For Live Auction Is Required ";
      if (!minPayout) error.minPayout = "Min Payout Is Required ";
      if (!paymentReminderForManualAuction)
        error.paymentReminderForManualAuction =
          "Payment Reminder For Manual Auction Is Required ";
      if (!zegoAppSignIn) error.zegoAppSignIn = "ZegoAppSignIn Is Required ";
      // if (!privacyPolicyLink)
      //   error.privacyPolicyLink = "Privacy Policy Link Is Required ";
      if (!resendkey)
        error.resendKey = "Resend Api Key Is Required ";
      // if (!termsAndConditionsLink)
      //   error.termsAndConditionsLink = "Terms And Conditions Link Is Required ";
      if (!openaiApiKey)
        error.openaiApiKey = "Openai Api Key Is Required ";
      // if (!privacyPolicyText)
      //   error.privacyPolicyText = "Privacy Policy Text Is Required ";

      if (!cancelOrderCharges)
        error.cancelOrderCharges = "Cancel Order Charges Is Required";
      if (cancelOrderCharges <= 0)
        error.cancelOrderCharges = "Enter Correct Cancel Order Charges";

      if (!adminCommissionCharges)
        error.adminCommissionCharges = "Admin Commission Charges Is Required";
      if (adminCommissionCharges <= 0)
        error.adminCommissionCharges =
          "Enter Correct Admin Commission Charges ";

      return setError({ ...error });
    } else {
      let settingData = {
        zegoAppId,
        paymentReminderForLiveAuction,
        minPayout,
        paymentReminderForManualAuction,
        zegoAppSignIn,
        // privacyPolicyLink,
        resendApiKey: resendkey,
        // termsAndConditionsLink,
        openaiApiKey,
        // privacyPolicyText,
        privateKey,
        adminCommissionCharges,
        cancelOrderCharges,
        priceMarkupPercent,
        // Gift/Coin conversion settings
        coinsPerCedi,
        giftPlatformCommission,
        minGiftWithdrawal,
        // Product limit settings
        defaultProductLimit,
        // Shipping / delivery fee engine
        shipping,
        // Flash Sale settings
        flashSaleEndDate: flashSaleEndDate || null,
        flashSaleEnabled,
        // Twilio SMS OTP Settings
        twilioAccountSid,
        twilioAuthToken,
        twilioVerifyServiceSid,
      };

      props.updateSetting(settingData, setting?._id);
    }
  };

  const handleClick = (field, toggleType) => {
    console.log("field", field, "toggleType", toggleType);

    // For simple toggles (productRequest, updateProductRequest, isFakeData), use handleToggleSwitch
    // For document field toggles (addressProof, govId, registrationCert), use handleSellerToggleSwitch
    if (toggleType) {
      // This is for document fields with isActive/isRequired toggles
      dispatch(handleSellerToggleSwitch(setting._id, field, toggleType));
    } else {
      // This is for simple on/off toggles
      dispatch(handleToggleSwitch(setting._id, field, setting));
    }
  };

  const handleAppVersionSubmit = () => {
    const appVersionData = {
      ios: {
        currentVersion: iosCurrentVersion,
        minimumVersion: iosMinimumVersion,
        storeUrl: iosStoreUrl,
        releaseNotes: iosReleaseNotes,
      },
      android: {
        currentVersion: androidCurrentVersion,
        minimumVersion: androidMinimumVersion,
        storeUrl: androidStoreUrl,
        releaseNotes: androidReleaseNotes,
      },
      forceUpdate: forceUpdate,
    };
    dispatch(updateAppVersion(appVersionData, setting?._id));
  };

  return (
    <>
      <div className="mainup">


        <div className="settingHeader primeHeader">
          <div className="col-12 headname" style={{ marginTop: "15px", marginBottom: "-5px", marginLeft: "2px" }}>App Setting </div>
        </div>
        <div className="settingMain">
          <div className="row" style={{ margin: "0px 2px" }}>
            {/*-------------- Box 1 --------------*/}
            <SettingBox title={`Zegocloud Setting`}>
              <Input
                type={`text`}
                label={`Zegocloud App Id`}
                value={zegoAppId}
                newClass={`col-12`}
                placeholder={`Enter Your Zegocloud App Id....`}
                errorMessage={error.zegoAppId && error.zegoAppId}
                onChange={(e) => {
                  setZegoAppId(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      zegoAppId: `Zegocloud App Id Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      zegoAppId: "",
                    });
                  }
                }}
              />
              <Input
                type={`text`}
                label={`Zegocloud App Sign In`}
                value={zegoAppSignIn}
                newClass={`col-12`}
                errorMessage={error.zegoAppSignIn && error.zegoAppSignIn}
                onChange={(e) => {
                  setZegoAppSignIn(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      zegoAppSignIn: `Zegocloud App Sign In Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      zegoAppSignIn: "",
                    });
                  }
                }}
              />

              <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <InfoTooltip
                  title="Zego App Id"
                  content={zegoApp}
                />
              </div>

            </SettingBox>


            <SettingBox title={`Auction Setting`}>
              <Input
                type={`number`}
                label={`Payment Reminder For LiveAuction (In Minutes)`}
                value={paymentReminderForLiveAuction}
                newClass={`col-12`}
                placeholder={`Enter Your Zegocloud App Id....`}
                errorMessage={error.paymentReminderForLiveAuction && error.paymentReminderForLiveAuction}
                onChange={(e) => {
                  setPaymentReminderForLiveAuction(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      paymentReminderForLiveAuction: `Payment Reminder For LiveAuction (In Minutes) Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      paymentReminderForLiveAuction: "",
                    });
                  }
                }}
              />
              <Input
                type={`number`}
                label={`Payment Reminder For ManualAuction (In Minutes)`}
                value={paymentReminderForManualAuction}
                newClass={`col-12`}
                errorMessage={error.paymentReminderForManualAuction && error.paymentReminderForManualAuction}
                onChange={(e) => {
                  setPaymentReminderForManualAuction(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      paymentReminderForManualAuction: `Payment Reminder For ManualAuction (In Minutes) Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      paymentReminderForManualAuction: "",
                    });
                  }
                }}
              />

              <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <InfoTooltip
                  title="Auction Setting"
                  content={auctionSetting}
                />
              </div>

            </SettingBox>

            {/*-------------- Box 2 --------------*/}
            {/* <SettingBox title={`App Setting`}>
              <Input
                type={`text`}
                label={`Privacy Policy Link ( redirect user to this link in app )`}
                value={privacyPolicyLink}
                newClass={`col-12`}
                placeholder={`Enter You Privacy Policy Link....`}
                errorMessage={
                  error.privacyPolicyLink && error.privacyPolicyLink
                }
                onChange={(e) => {
                  setPrivacyPolicyLink(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      privacyPolicyLink: `Privacy Policy Link Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      privacyPolicyLink: "",
                    });
                  }
                }}
              />

              <Input
                type={`text`}
                label={`Privacy Policy Text`}
                value={privacyPolicyText}
                newClass={`col-12`}
                placeholder={`Enter You Privacy Policy Text....`}
                errorMessage={
                  error.privacyPolicyText && error.privacyPolicyText
                }
                onChange={(e) => {
                  setPrivacyPolicyText(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      privacyPolicyText: `Privacy Policy Text Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      privacyPolicyText: "",
                    });
                  }
                }}
              />
            </SettingBox> */}

            {/* Box 7 */}
            <SettingBox
              title={`Add Product Request`}
              title2={`New product request enable/disable for seller`}
              toggleSwitch={{
                switchValue: isAddProductRequest,
                handleClick: () => {
                  handleClick("productRequest");
                },
              }}
            ></SettingBox>
            <SettingBox
              title={`Update Product Request`}
              title2={`Enable/disable product request update for seller`}
              toggleSwitch={{
                switchValue: isUpdateProductRequest,
                handleClick: () => {
                  handleClick("updateProductRequest");
                },
              }}
            ></SettingBox>

            <SettingBox title={`Charges Setting`}>
              <Input
                type={`number`}
                label={`Cancel Order Charges (%)`}
                value={cancelOrderCharges}
                newClass={`col-6 pb-2`}
                placeholder={`Enter You Cancle Order Charge....`}
                errorMessage={
                  error.cancelOrderCharges && error.cancelOrderCharges
                }
                onChange={(e) => {
                  setCancelOrderCharges(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      cancelOrderCharges: `Cancle Order ChargeIs Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      cancelOrderCharges: "",
                    });
                  }
                }}
              />

              <Input
                type={`number`}
                label={`Admin Commission Charges (%)`}
                value={adminCommissionCharges}
                newClass={`col-6`}
                placeholder={`Enter You Admin Commission Charges`}
                errorMessage={
                  error.adminCommissionCharges && error.adminCommissionCharges
                }
                onChange={(e) => {
                  setAdminCommissionCharges(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      adminCommissionCharges: `Admin Commission Charges Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      adminCommissionCharges: "",
                    });
                  }
                }}
              />

              <Input
                type={`number`}
                label={`Price Markup (%) — FX buffer on seller prices`}
                value={priceMarkupPercent}
                newClass={`col-6 pb-2`}
                placeholder={`e.g. 5`}
                onChange={(e) => setPriceMarkupPercent(e.target.value)}
              />

              <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <InfoTooltip
                  title="Charges Setting"
                  content={chargesSetting}
                />
              </div>
            </SettingBox>

            {/* Gift/Coin Conversion Settings */}
            <SettingBox title={`Gift & Coin Settings`}>
              <Input
                type={`number`}
                label={`Coins Per Cedi (Conversion Rate)`}
                value={coinsPerCedi}
                newClass={`col-4 pb-2`}
                placeholder={`e.g. 10`}
                onChange={(e) => {
                  setCoinsPerCedi(e.target.value);
                }}
              />

              <Input
                type={`number`}
                label={`Gift Platform Commission (%)`}
                value={giftPlatformCommission}
                newClass={`col-4 pb-2`}
                placeholder={`e.g. 30`}
                onChange={(e) => {
                  setGiftPlatformCommission(e.target.value);
                }}
              />

              <Input
                type={`number`}
                label={`Min Gift Withdrawal (Coins)`}
                value={minGiftWithdrawal}
                newClass={`col-4 pb-2`}
                placeholder={`e.g. 100`}
                onChange={(e) => {
                  setMinGiftWithdrawal(e.target.value);
                }}
              />

              <div className="col-12 mt-2" style={{ fontSize: "12px", color: "#666" }}>
                <p className="mb-1"><strong>Conversion Rate:</strong> {coinsPerCedi} coins = $1</p>
                <p className="mb-1"><strong>Creator Earning:</strong> {100 - giftPlatformCommission}% of gift value</p>
                <p className="mb-0"><strong>Platform Commission:</strong> {giftPlatformCommission}% of gift value</p>
              </div>
            </SettingBox>

            {/* Product Limit Settings */}
            <SettingBox title={`Product Upload Limit (Seller)`}>
              <Input
                type={`number`}
                label={`Default Product Limit`}
                value={defaultProductLimit}
                newClass={`col-12 pb-2`}
                placeholder={`e.g. 50 (0 for unlimited)`}
                onChange={(e) => {
                  setDefaultProductLimit(e.target.value);
                }}
              />

              <div className="col-12 mt-2" style={{ fontSize: "12px", color: "#666" }}>
                <p className="mb-1"><strong>Default Limit:</strong> {defaultProductLimit === 0 || defaultProductLimit === "0" ? "Unlimited" : `${defaultProductLimit} products per seller`}</p>
                <p className="mb-0"><strong>Note:</strong> Set to 0 for unlimited products. Individual seller limits can be set from the Seller page.</p>
              </div>
            </SettingBox>

            {/* Shipping / Delivery Fee Settings */}
            <SettingBox title={`Shipping / Delivery Fee`}>
              <Input
                type={`number`}
                label={`Base Fee — Local Pickup (${shipping.currency})`}
                value={shipping.basePickup}
                newClass={`col-6 pb-2`}
                placeholder={`e.g. 14`}
                onChange={(e) => setShipField("basePickup", e.target.value)}
              />
              <Input
                type={`number`}
                label={`Base Fee — Door Delivery (${shipping.currency})`}
                value={shipping.baseDoor}
                newClass={`col-6 pb-2`}
                placeholder={`e.g. 20`}
                onChange={(e) => setShipField("baseDoor", e.target.value)}
              />
              <Input
                type={`number`}
                label={`Per-km Rate 0–15 km (${shipping.currency}/km)`}
                value={(shipping.perKmTiers?.[0]?.rate) ?? ""}
                newClass={`col-4 pb-2`}
                placeholder={`e.g. 2`}
                onChange={(e) => setTierRate(0, e.target.value)}
              />
              <Input
                type={`number`}
                label={`Per-km Rate 15–50 km (${shipping.currency}/km)`}
                value={(shipping.perKmTiers?.[1]?.rate) ?? ""}
                newClass={`col-4 pb-2`}
                placeholder={`e.g. 1.5`}
                onChange={(e) => setTierRate(1, e.target.value)}
              />
              <Input
                type={`number`}
                label={`Per-km Rate 50+ km (${shipping.currency}/km)`}
                value={(shipping.perKmTiers?.[2]?.rate) ?? ""}
                newClass={`col-4 pb-2`}
                placeholder={`e.g. 1`}
                onChange={(e) => setTierRate(2, e.target.value)}
              />
              <Input
                type={`number`}
                label={`Weight Free Allowance (kg)`}
                value={shipping.weightFreeKg}
                newClass={`col-4 pb-2`}
                placeholder={`e.g. 5`}
                onChange={(e) => setShipField("weightFreeKg", e.target.value)}
              />
              <Input
                type={`number`}
                label={`Weight Surcharge (${shipping.currency}/kg over allowance)`}
                value={shipping.weightSurchargePerKg}
                newClass={`col-4 pb-2`}
                placeholder={`e.g. 2`}
                onChange={(e) => setShipField("weightSurchargePerKg", e.target.value)}
              />
              <Input
                type={`number`}
                label={`Road Factor (great-circle fallback ×)`}
                value={shipping.roadFactor}
                newClass={`col-4 pb-2`}
                placeholder={`e.g. 1.3`}
                onChange={(e) => setShipField("roadFactor", e.target.value)}
              />
              <div className="col-12 mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1 fw-semibold">Shipping Engine Active</h6>
                    <small className="text-muted">When off, fee falls back to engine defaults</small>
                  </div>
                  <ToggleSwitch
                    value={shipping.isActive}
                    onClick={() => setShipField("isActive", !shipping.isActive)}
                  />
                </div>
              </div>
              <div className="col-12 mt-1" style={{ fontSize: "12px", color: "#666" }}>
                <p className="mb-0">
                  <strong>Formula:</strong> fee = base + (distance × per-km rate) + max(0, weight − {shipping.weightFreeKg}kg) × {shipping.weightSurchargePerKg}.
                  Rates in {shipping.currency}; converted to USD-base at checkout.
                </p>
              </div>
            </SettingBox>

            {/* Flash Sale Settings */}
            <SettingBox title={`Flash Sale Settings`}>
              <div className="col-12 mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1 fw-semibold">Enable Flash Sale</h6>
                    <small className="text-muted">Turn on/off flash sale section on homepage</small>
                  </div>
                  <ToggleSwitch
                    value={flashSaleEnabled}
                    onClick={() => setFlashSaleEnabled(!flashSaleEnabled)}
                  />
                </div>
              </div>

              {flashSaleEnabled && (
                <div className="col-12">
                  <label className="form-label fw-semibold" style={{ color: "#999AA4" }}>
                    Flash Sale End Date & Time
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    value={flashSaleEndDate}
                    onChange={(e) => setFlashSaleEndDate(e.target.value)}
                    min={new Date().toISOString().slice(0, 16)}
                    style={{ borderColor: "#ced4da", borderRadius: "6px" }}
                  />
                  <small className="text-muted d-block mt-2">
                    Set the global end date for all flash sale products. This countdown will be displayed on the homepage.
                  </small>
                </div>
              )}

              <div className="col-12 mt-3" style={{ fontSize: "12px", color: "#666" }}>
                <p className="mb-1"><strong>Status:</strong> {flashSaleEnabled ? "Flash Sale Active" : "Flash Sale Disabled"}</p>
                {flashSaleEndDate && flashSaleEnabled && (
                  <p className="mb-0"><strong>Ends:</strong> {new Date(flashSaleEndDate).toLocaleString()}</p>
                )}
              </div>
            </SettingBox>

            <SettingBox title={`Resend API Setting`}>
              <Input
                type={`text`}
                label={`Resend Api Key`}
                value={resendkey}
                newClass={`col-12`}
                placeholder={`Enter You Resend Api Key here`}
                errorMessage={
                  error.resendKey && error.resendKey
                }
                onChange={(e) => {
                  setResendKey(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      resendKey: `Resend Api Key Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      resendKey: "",
                    });
                  }
                }}
              />

              <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <InfoTooltip
                  title="Resend API Key"
                  content={resendApiSetting}
                />
              </div>
            </SettingBox>

            {/* Twilio SMS OTP Settings */}
            <SettingBox
              title={`Twilio SMS OTP Setting`}
              title2={`Enable/Disable SMS OTP verification`}
              toggleSwitch={{
                switchValue: twilioSwitch,
                handleClick: () => {
                  handleClick("twilio");
                  setTwilioSwitch(!twilioSwitch);
                },
              }}
            >
              <Input
                type={`text`}
                label={`Account SID`}
                value={twilioAccountSid}
                newClass={`col-12`}
                placeholder={`Enter Twilio Account SID (starts with AC...)`}
                onChange={(e) => {
                  setTwilioAccountSid(e.target.value);
                }}
              />
              <Input
                type={`password`}
                label={`Auth Token`}
                value={twilioAuthToken}
                newClass={`col-12`}
                placeholder={`Enter Twilio Auth Token`}
                onChange={(e) => {
                  setTwilioAuthToken(e.target.value);
                }}
              />
              <Input
                type={`text`}
                label={`Verify Service SID`}
                value={twilioVerifyServiceSid}
                newClass={`col-12`}
                placeholder={`Enter Verify Service SID (starts with VA...)`}
                onChange={(e) => {
                  setTwilioVerifyServiceSid(e.target.value);
                }}
              />

              <div className="col-12 mt-2" style={{ fontSize: "12px", color: "#666" }}>
                <p className="mb-1"><strong>Status:</strong> {twilioSwitch ? "SMS OTP Enabled" : "SMS OTP Disabled"}</p>
                <p className="mb-0"><strong>Note:</strong> Get credentials from <a href="https://console.twilio.com" target="_blank" rel="noreferrer">Twilio Console</a>. Create a Verify Service for OTP.</p>
              </div>
            </SettingBox>

            <SettingBox title={`Minimum Withdrawal Limit (Seller) (${setting?.currency?.currencyCode})`}>
              <Input
                type={`number`}
                label={`Minimum Withdrawal Amount`}
                value={minPayout}
                newClass={`col-12`}
                placeholder={`Enter Amount....`}
                errorMessage={error.minPayout && error.minPayout}
                onChange={(e) => {
                  setMinPayout(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      minPayout: `Minimum Withdrawal Amount Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      minPayout: "",
                    });
                  }
                }}
              />

              <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <InfoTooltip
                  title="Withdrawal Setting"
                  content={withdrawalSetting}
                />
              </div>

            </SettingBox>

            <SettingBox title={`Open AI Key Setting`}>
              <Input
                type={`text`}
                label={`Open AI Key`}
                value={openaiApiKey}
                newClass={`col-12`}
                placeholder={`Enter You Open AI Key here`}
                errorMessage={
                  error.openaiApiKey && error.openaiApiKey
                }
                onChange={(e) => {
                  setOpenaiApiKey(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      openaiApiKey: `Open AI Key Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      openaiApiKey: "",
                    });
                  }
                }}
              />

              <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <InfoTooltip
                  title="Open AI Setting"
                  content={openAISetting}
                />
              </div>

            </SettingBox>



            <SettingBox title={`Firebase Notification Setting `}>
              <div className="prime-input">
                <label
                  className="float-left styleForTitle"
                  style={{
                    color: "#999AA4"
                  }}
                  htmlFor="privateKey"
                >
                  Private Key JSON ( To handle firebase push notification )
                </label>
                <textarea
                  name=""
                  className="form-control mt-2"
                  id="privateKey"
                  rows={10}
                  value={privateKey}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    try {
                      const newData = JSON.parse(newValue);
                      setPrivateKey(newValue);
                      setError("");
                    } catch (error) {
                      // Handle invalid JSON input
                      console.error("Invalid JSON input:", error);
                      setPrivateKey(newValue);
                      return setError({
                        ...error,
                        privateKey: "Invalid JSON input",
                      });
                    }
                  }}
                ></textarea>

                {error.privateKey && (
                  <div className="pl-1 text-left">
                    <p className="errorMessage">{error.privateKey}</p>
                  </div>
                )}
              </div>

              <div style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <InfoTooltip
                  title="Firebase Notification"
                  content={privateKeyJson}
                />
              </div>
            </SettingBox>

            <SettingBox
              title={`Fake Data`}
              title2={`Disable/Enable fake data in app`}
              toggleSwitch={{
                switchName: " ",
                switchValue: isFakeData,
                handleClick: () => {
                  handleClick("isFakeData");
                },
              }}
            >
            </SettingBox>
            {/* <SettingBox title={`Become Seller Setting`}>
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="me-2 fw-semibold">Address Proof</h5>
                <div className="d-flex gap-5">
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Require</span>
                    <ToggleSwitch
                      value={setting?.addressProof?.isRequired}
                      onClick={() => handleClick("addressProof", "isRequired")}
                    />
                  </div>
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Active</span>
                    <ToggleSwitch
                      value={setting?.addressProof?.isActive}
                      onClick={() => handleClick("addressProof", "isActive")}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <h5 className="me-2 fw-semibold">Government ID</h5>
                <div className="d-flex gap-5">
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Require</span>
                    <ToggleSwitch
                      value={setting?.govId?.isRequired}
                      onClick={() => handleClick("govId", "isRequired")}
                    />
                  </div>
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Active</span>
                    <ToggleSwitch
                      value={setting?.govId?.isActive}
                      onClick={() => handleClick("govId", "isActive")}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <h5 className="me-2 fw-semibold">Registration Certificate</h5>
                <div className="d-flex gap-5">
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Require</span>
                    <ToggleSwitch
                      value={setting?.registrationCert?.isRequired}
                      onClick={() => handleClick("registrationCert", "isRequired")}
                    />
                  </div>
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Active</span>
                    <ToggleSwitch
                      value={setting?.registrationCert?.isActive}
                      onClick={() => handleClick("registrationCert", "isActive")}
                    />
                  </div>
                </div>
              </div>
            </SettingBox> */}
            {/* App Version Settings */}
            <SettingBox title={`App Version Settings (In-App Update)`}>
              <div className="col-12 mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1 fw-semibold">Force Update</h6>
                    <small className="text-muted">Require users to update before using the app</small>
                  </div>
                  <ToggleSwitch
                    value={forceUpdate}
                    onClick={() => setForceUpdate(!forceUpdate)}
                  />
                </div>
              </div>

              {/* iOS Settings */}
              <div className="col-12 mb-3">
                <h6 className="fw-semibold" style={{ color: "#007AFF", borderBottom: "1px solid #e0e0e0", paddingBottom: "8px" }}>
                  iOS Settings
                </h6>
              </div>
              <Input
                type={`text`}
                label={`iOS Current Version`}
                value={iosCurrentVersion}
                newClass={`col-6 pb-2`}
                placeholder={`e.g. 1.0.0`}
                onChange={(e) => setIosCurrentVersion(e.target.value)}
              />
              <Input
                type={`text`}
                label={`iOS Minimum Version`}
                value={iosMinimumVersion}
                newClass={`col-6 pb-2`}
                placeholder={`e.g. 1.0.0`}
                onChange={(e) => setIosMinimumVersion(e.target.value)}
              />
              <Input
                type={`text`}
                label={`iOS App Store URL`}
                value={iosStoreUrl}
                newClass={`col-12 pb-2`}
                placeholder={`https://apps.apple.com/app/your-app-id`}
                onChange={(e) => setIosStoreUrl(e.target.value)}
              />
              <div className="col-12 pb-3">
                <label className="float-left styleForTitle" style={{ color: "#999AA4" }}>
                  iOS Release Notes
                </label>
                <textarea
                  className="form-control mt-2"
                  rows={3}
                  value={iosReleaseNotes}
                  placeholder="What's new in this version..."
                  onChange={(e) => setIosReleaseNotes(e.target.value)}
                ></textarea>
              </div>

              {/* Android Settings */}
              <div className="col-12 mb-3 mt-2">
                <h6 className="fw-semibold" style={{ color: "#3DDC84", borderBottom: "1px solid #e0e0e0", paddingBottom: "8px" }}>
                  Android Settings
                </h6>
              </div>
              <Input
                type={`text`}
                label={`Android Current Version`}
                value={androidCurrentVersion}
                newClass={`col-6 pb-2`}
                placeholder={`e.g. 1.0.0`}
                onChange={(e) => setAndroidCurrentVersion(e.target.value)}
              />
              <Input
                type={`text`}
                label={`Android Minimum Version`}
                value={androidMinimumVersion}
                newClass={`col-6 pb-2`}
                placeholder={`e.g. 1.0.0`}
                onChange={(e) => setAndroidMinimumVersion(e.target.value)}
              />
              <Input
                type={`text`}
                label={`Android Play Store URL`}
                value={androidStoreUrl}
                newClass={`col-12 pb-2`}
                placeholder={`https://play.google.com/store/apps/details?id=com.yourapp`}
                onChange={(e) => setAndroidStoreUrl(e.target.value)}
              />
              <div className="col-12 pb-3">
                <label className="float-left styleForTitle" style={{ color: "#999AA4" }}>
                  Android Release Notes
                </label>
                <textarea
                  className="form-control mt-2"
                  rows={3}
                  value={androidReleaseNotes}
                  placeholder="What's new in this version..."
                  onChange={(e) => setAndroidReleaseNotes(e.target.value)}
                ></textarea>
              </div>

              <div className="col-12 mt-2" style={{ fontSize: "12px", color: "#666" }}>
                <p className="mb-1"><strong>Current Version:</strong> The latest version available in stores</p>
                <p className="mb-1"><strong>Minimum Version:</strong> Oldest supported version (users below this will be forced to update)</p>
                <p className="mb-0"><strong>Force Update:</strong> When enabled, all users with older versions must update</p>
              </div>

              <div className="col-12 mt-3 d-flex justify-content-end">
                <Button
                  newClass={`whiteFont`}
                  btnName={`Save Version Settings`}
                  btnColor={`#F0C420`}
                  style={{ borderRadius: "6px", color: "#fff", backgroundColor: "#F0C420" }}
                  onClick={handleAppVersionSubmit}
                />
              </div>
            </SettingBox>

            <SettingBox title={`Become Seller Setting`} className="mb-5">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div style={{ width: "200px" }} />
                <span className="fw-semibold" style={{ width: "80px", textAlign: "center" }}>Require</span>
                <span className="fw-semibold" style={{ width: "80px", textAlign: "center" }}>Active</span>
              </div>

              {/* Address Proof Row */}
              <div className="d-flex justify-content-between align-items-center mt-2">
                <h5 className="me-2 fw-semibold" style={{ width: "200px" }}>Address Proof</h5>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.addressProof?.isRequired}
                    onClick={() => {
                      handleClick("addressProof", "isRequired");
                      if (setting?.addressProof?.isActive === false && setting?.addressProof?.isRequired === false) {
                        setTimeout(() => {
                          handleClick("addressProof", "isActive");
                        }, 1000); // 2 second delay, apko jitna chahiye adjust kar sakte hain
                      }
                    }}
                  />
                </div>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.addressProof?.isActive}
                    onClick={() => {
                      handleClick("addressProof", "isActive");
                      if (setting?.addressProof?.isRequired === true && setting?.addressProof?.isActive === true) {
                        setTimeout(() => {
                          handleClick("addressProof", "isRequired");
                        }, 1000);
                      }
                    }}
                  />
                </div>
              </div>


              {/* Government ID Row */}
              <div className="d-flex justify-content-between align-items-center mt-2">
                <h5 className="me-2 fw-semibold" style={{ width: "200px" }}>Government ID</h5>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.govId?.isRequired}
                    onClick={() => {
                      handleClick("govId", "isRequired");
                      if (setting?.govId?.isActive === false && setting?.govId?.isRequired === false) {
                        setTimeout(() => {
                          handleClick("govId", "isActive");
                        }, 1000);
                      }
                    }}
                  />
                </div>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.govId?.isActive}
                    onClick={() => {
                      handleClick("govId", "isActive");
                      if (setting?.govId?.isRequired === true && setting?.govId?.isActive === true) {
                        setTimeout(() => {
                          handleClick("govId", "isRequired");
                        }, 1000);
                      }
                    }}
                  />
                </div>
              </div>

              {/* Registration Certificate Row */}
              <div className="d-flex justify-content-between align-items-center mt-2">
                <h5 className="me-2 fw-semibold" style={{ width: "200px", whiteSpace: "nowrap" }}>Registration Certificate</h5>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.registrationCert?.isRequired}
                    onClick={() => {
                      handleClick("registrationCert", "isRequired");
                      if (setting?.registrationCert?.isActive === false && setting?.registrationCert?.isRequired === false) {
                        setTimeout(() => {
                          handleClick("registrationCert", "isActive");
                        }, 1000);
                      }
                    }}
                  />
                </div>
                <div style={{ width: "80px", textAlign: "center" }}>
                  <ToggleSwitch
                    value={setting?.registrationCert?.isActive}
                    onClick={() => {
                      handleClick("registrationCert", "isActive");
                      if (setting?.registrationCert?.isRequired === true && setting?.registrationCert?.isActive === true) {
                        setTimeout(() => {
                          handleClick("registrationCert", "isRequired");
                        }, 1000);
                      }
                    }}
                  />
                </div>
              </div>
            </SettingBox>

            {/* <SettingBox title={`Terms And Conditions`}>
              <Input
                type={`text`}
                label={`Terms And Conditions Link`}
                value={termsAndConditionsLink}
                newClass={`col-12`}
                placeholder={`Enter You Terms And Conditions Link Here`}
                errorMessage={
                  error.termsAndConditionsLink && error.termsAndConditionsLink
                }
                onChange={(e) => {
                  setTermsAndConditionsLink(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      termsAndConditionsLink: `Terms And Conditions Link Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      termsAndConditionsLink: "",
                    });
                  }
                }}
              />
            </SettingBox> */}

            {/* <ReactQuill
            className="mt-4"
              theme="snow"
              value={termsAndConditionsLink}
              onChange={(content) => {
                setTermsAndConditionsLink(content);
                if (error.termsAndConditionsLink) {
                  setError({ ...error, termsAndConditionsLink: null });
                }
              }}
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, false] }],
                  ["bold", "italic", "underline", "strike", "blockquote"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link", "image"],
                  ["clean"],
                ],
              }}
              placeholder="Write your Terms and Conditions here..."
            />
            {error.termsAndConditionsLink && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {error.termsAndConditionsLink}
              </div>
            )} */}

          </div>
          <div className="row mt-5">
            <div className="col-12 d-flex justify-content-end">
              <Button
                newClass={`whiteFont`}
                btnName={`Submit`}
                btnColor={`#F0C420`}
                style={{ width: "90px", borderRadius: "6px", color: "#fff", backgroundColor: "#F0C420", marginBottom: "20px" }}
                onClick={(e) => handleSubmit(e)}
              />
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default connect(null, {
  getSetting,
  updateSetting,
  handleToggleSwitch,
  getWithdraw,
  updateAppVersion,
})(Setting);
